import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility.js';

const urlParams = new URLSearchParams(window.location.search);
if(urlParams.get('AuthToken') && urlParams.get('UserId')) {
    localStorage.setItem('token', urlParams.get('AuthToken'));
    localStorage.setItem('user_id', urlParams.get('UserId'));
}

const initialState = {
    token : localStorage.getItem("token"),
    user_id: localStorage.getItem("user_id"),
    isAuthenticated : localStorage.getItem("token") ? true : false,
    warning: false,
	first_name: false,
	last_name: false,
    account_name: undefined,
    parent_user_id: undefined,
    impersonation_for_id: undefined,
    loading: false,
    error: false,
    user_name: false,
    expired: false,
    deleted: false
};

/* ----------------- Auth ------------------ */
const authChangeCurrentUser = (state, action) => {
    return updateObject( state, {
        token: action.token,
        user_id: action.user_id,
        warning: action.warning,
		first_name:action.first_name,
		last_name:action.last_name,		
        account_name:action.account_name,
        parent_user_id: action.parent_user_id ? action.parent_user_id : undefined,
        impersonation_for_id: action.impersonation_for_id ? action.impersonation_for_id : undefined,
        isAuthenticated: action.token ? true : false,
        loading: false,
        error: false
    } );
}

const authSetMelcoAccountData = ( state, action ) => {
    return updateObject( state, {} );
};

const authRemoveMelcoAccountData = ( state, action ) => {
    return updateObject( state, {} );
};

const authLogoutOnServerStart = ( state, action ) => {
    return updateObject( state, { loading: true, error: false } );
};

const authLogoutOnServerSuccess = ( state, action ) => {
    return updateObject( state, {
        token: null,
        user_id: null,
        warning: false,
		first_name: false,
		last_name: false,	
        account_name: false,
        parent_user_id: undefined,
        impersonation_for_id: undefined,	
        isAuthenticated: false,
        loading: false,
        error: false        
    } );
};

const authLogoutOnServerFail = ( state, action ) => {
    return updateObject( state, { loading: false, error: action.error } );
};

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.AUTH_SET_MELCO_ACCOUNT_DATA: return authSetMelcoAccountData( state, action);
        case actionTypes.AUTH_REMOVE_MELCO_ACCOUNT_DATA: return authRemoveMelcoAccountData( state, action);
        case actionTypes.AUTH_CHANGE_CURRENT_USER: return authChangeCurrentUser( state, action );
        case actionTypes.AUTH_LOGOUT_ON_SERVER_START: return authLogoutOnServerStart( state, action);
        case actionTypes.AUTH_LOGOUT_ON_SERVER_SUCCESS: return authLogoutOnServerSuccess( state, action);
        case actionTypes.AUTH_LOGOUT_ON_SERVER_FAIL: return authLogoutOnServerFail( state, action);
        default: return state;
    }
};


export default reducer;


// WEBPACK FOOTER //
// ./src/_store/reducers/auth.js